if (!customElements.get('lets-get-real-belief')) {
  customElements.define('lets-get-real-belief', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal:this.controller.signal, passive:true };
      this.myth = this.words('[data-myth]');
      this.real = this.words('[data-real]');
      this.badge = this.querySelector('.lgr-belief__badge');
      this.content = this.querySelector('.lgr-belief__content');
      this.pin = this.querySelector('.lgr-belief__pin');
      this.sheet = this.closest('.section-lets-get-real-belief');
      this.heroSection = this.sheet?.previousElementSibling;
      if (!this.heroSection?.matches('.section-lets-get-real-hero')) this.heroSection = null;
      this.hero = this.heroSection?.querySelector('lets-get-real-hero');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-ready');
      this.schedule = () => {
        if (this.ticking) return;
        this.ticking = true;
        this.frame = requestAnimationFrame(() => { this.ticking = false; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', () => this.measure(), options);
      this.motion.addEventListener('change', () => this.measure(), options);
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this.content);
      this.measure();
    }
    words(selector) {
      const container = this.querySelector(selector);
      const words = container.textContent.trim().split(/\s+/).filter(Boolean);
      container.replaceChildren();
      return words.map((word, index) => {
        const span = document.createElement('span');
        span.className = 'lgr-belief__word';
        span.textContent = word;
        // Zero-width breaks retain wrapping; normal spaces keep copied text readable.
        if (index) container.append(document.createTextNode(' '));
        container.append(span);
        return span;
      });
    }
    measure() {
      const header = parseFloat(getComputedStyle(this).getPropertyValue('--hd'));
      this.static = this.motion.matches || this.content.offsetHeight > innerHeight - header - 32;
      this.classList.toggle('is-static', this.static);
      const curtain = !!this.hero && !this.motion.matches;
      this.heroSection?.classList.toggle('lgr-curtain', curtain);
      this.sheet?.classList.toggle('lgr-sheet', curtain);
      this.update();
    }
    update() {
      const clamp = value => Math.max(0, Math.min(1, value));
      const rect = this.getBoundingClientRect();
      const run = rect.height - this.pin.offsetHeight;
      const progress = this.static || run <= 0 ? 1 : clamp(-rect.top / run);
      const fill = (words, value, name) => words.forEach((word, i) => word.classList.toggle(name, i < Math.round(clamp(value) * words.length)));
      fill(this.myth, progress / .4, 'is-lit');
      fill(this.myth, (progress - .42) / .16, 'is-x');
      fill(this.real, (progress - .6) / .34, 'is-lit');
      this.badge.classList.toggle('is-real', progress >= .58);
      if (this.hero) {
        const distance = this.heroSection.offsetHeight - this.hero.querySelector('.lgHero').offsetHeight;
        const curtain = this.motion.matches ? 0 : clamp(1 - this.sheet.getBoundingClientRect().top / Math.max(1, distance));
        this.hero.style.setProperty('--s', curtain);
        this.sheet.style.setProperty('--lgr-progress', curtain);
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort(); this.controller = null;
      this.resize?.disconnect(); this.ticking = false;
      this.heroSection?.classList.remove('lgr-curtain');
      this.sheet?.classList.remove('lgr-sheet');
      this.hero?.style.removeProperty('--s');
      this.classList.remove('is-ready');
    }
  });
}